import { PriceRow } from "src/api";

import { Icon } from "../icons/Icon";
import { type AllIcons } from "../icons/iconTypes";
import { ItemCost } from "./ItemCost";
import "./ItemTile.css";
import { StyledButtonContainer } from "./StyledButtonContainer";

export type ItemTileProps = {
  icon: AllIcons;
  rows: readonly PriceRow[];
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
};

export function ItemTile(props: ItemTileProps) {
  const { icon, rows, selected, disabled, onClick } = props;

  return (
    <StyledButtonContainer
      className="item-tile"
      selected={selected}
      disabled={disabled}
      onClick={onClick}
    >
      <div className="item-tile-content">
        <Icon icon={icon} className="item-tile-icon" />
        <ItemCost rows={rows} />
      </div>
    </StyledButtonContainer>
  );
}
